import { SET_CATEGORY_TREE } from 'store/actions'

const categoryTreeReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_CATEGORY_TREE:
      return action.categoryTree
    default:
      return state
  }
}

export default categoryTreeReducer
